import { capitalizeHeader } from "../../../utils/capitalize";

export default function ComingSoon({ title }: { title: string }) {
  return (
    <>
      <h1 className="text-2xl md:text-3xl font-medium text-primary font-decimal mb-4 md:mb-6">
        {capitalizeHeader(title)}
      </h1>
      <div className="flex flex-col items-center justify-center w-full py-6 md:py-10 bg-gray-15">
        <p className="text-base md:text-lg font-normal text-primary font-roboto">
          More Information Coming Soon
        </p>
      </div>
    </>
  );
}
